import React from "react";
import SolicitudPadronServicio from "../../../servicios/SolicitudDePadron";
import ParametrosSolicitud from "../../../Contenedores/Padron/ParametrosSolicitud";
import ResultadoConsultaSolicitud from "./ResultadoConsultaSolicitud";
import { Notificar, CerrarNotificador } from "../../Comunes/Notificador";
import moment from "moment";
import { withRouter } from "react-router-dom";

class ParametrosConsultaSolicitud extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      datos: [],
      mostrarTabla: false,
      opcionesClaseDatos: [],
      opcionesFechas: [],
      opcionesEstados: [],
      opcionesTipoSolicitud: [],
      seleccionClaseDato: "0",
      SeleccionFecha: "0",
      seleccionEstado: "0",
      seleccionTipoSolicitud: "0",
      defaultOptionClaseDato: "0",
      defaultOptionFecha: "0",
      defaultOptionTipoSolicitud: "0",
      defaultOptionEstado: "0",
      parametrosCargados: null,
      PaginaDatatable: 0,
      UnaVez: false,
    };
    this._onConsultaSolicitudes = this._onConsultaSolicitudes.bind(this);
    this._onSelectClaseDato = this._onSelectClaseDato.bind(this);
    this._onSelectFechas = this._onSelectFechas.bind(this);
    this._onSelectEstado = this._onSelectEstado.bind(this);
    this._onSelectTipoSolicitud = this._onSelectTipoSolicitud.bind(this);
    this.limpiarFiltros = this.limpiarFiltros.bind(this);
  }

  async componentDidMount() {
    let parametrosCargados =
      this.props.ParametrosCargados !== null
        ? JSON.parse(this.props.ParametrosCargados)
        : null;

    if (parametrosCargados !== null) {
      await this.CargarPantallaPreCargada(parametrosCargados);
      this.setState({
        parametrosCargados: parametrosCargados,
      });
    }
    await this.CargarParametrosSolicitud();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.ParametrosCargados !== this.props.ParametrosCargados) {
      await this.CargarParametrosSolicitud();
      this.focusRef.current.focus();
    }
  }

  async CargarPantallaPreCargada(parametros) {
    document.getElementById("Identificacion").value =
      parametros.Identificacion ?? "";
    document.getElementById("Nombre").value = parametros.Nombre ?? "";
    let storage = localStorage.getItem(
      "DataTables_tbSolicitudesPadron_/cic_externo/Padron/ConsultaSolicitudesPadron"
    );

    this.setState({
      seleccionEstado: parametros.TipoEstado,
      seleccionTipoSolicitud: parametros.TipoSolicitud,
      seleccionClaseDato: parametros.IdClaseDato,
      SeleccionFecha: parametros.FechaSolicitud,
      defaultOptionClaseDato: parametros.IdClaseDato ?? "0",
      defaultOptionFecha: parametros.FechaSolicitud ?? "0",
      defaultOptionEstado: parametros.TipoEstado ?? "0",
      defaultOptionTipoSolicitud: parametros.TipoSolicitud ?? "0",
      UnaVez: true,
      PaginaDatatable: storage !== undefined ? storage.start : 0,
    });
  }

  cargarParametros() {
    let parametro = new ParametrosSolicitud();
    let Identificacion = document.getElementById("Identificacion").value;
    let nombre = document.getElementById("Nombre").value;

    parametro.IdClaseDato =
      this.state.seleccionClaseDato === "0"
        ? null
        : this.state.seleccionClaseDato;
    parametro.FechaSolicitud =
      this.state.SeleccionFecha === "0" || this.state.SeleccionFecha === null
        ? null
        : new Date(this.state.SeleccionFecha);
    parametro.TipoEstado =
      this.state.seleccionEstado === "0" ? null : this.state.seleccionEstado;
    parametro.TipoSolicitud =
      this.state.seleccionTipoSolicitud === "0"
        ? null
        : this.state.seleccionTipoSolicitud;
    parametro.Identificacion = Identificacion === "" ? null : Identificacion;
    parametro.Nombre = nombre === "" ? null : nombre;

    return parametro;
  }

  limpiarFiltros = () => {
    document.getElementById("Identificacion").value = "";
    document.getElementById("Nombre").value = "";

    this.setState(
      {
        seleccionEstado: "0",
        seleccionTipoSolicitud: "0",
        seleccionClaseDato: "0",
        SeleccionFecha: "0",
        defaultOptionClaseDato: "0",
        defaultOptionFecha: "0",
        defaultOptionEstado: "0",
        defaultOptionTipoSolicitud: "0",
      },
      () => this.CargarParametrosSolicitud()
    );
  };

  CargarParametrosSolicitud = async () => {
    let parametros = this.cargarParametros();
    let resultado = await SolicitudPadronServicio.ObtengaParametrosSolicitud(
      parametros
    );

    this.setState({
      opcionesClaseDatos: resultado.ListaClaseDatos ?? {
        key: "Error en la carga de datos",
        value: "0",
      },
      opcionesFechas: resultado.ListaFechasEnvio ?? {
        key: "Error en la carga de datos",
        value: "0",
      },
      opcionesEstados: resultado.ListaEstado ?? {
        key: "Error en la carga de datos",
        value: "0",
      },
      opcionesTipoSolicitud: resultado.ListaTiposSolicitud ?? {
        key: "Error en la carga de datos",
        value: "0",
      },
    });
    await this.cargarDefaultData();
  };

  async _onSelectClaseDato(e) {
    this.setState(
      {
        seleccionClaseDato: e.target.value,
        defaultOptionClaseDato: e.target.value,
      },
      () => this.CargarParametrosSolicitud()
    );
  }

  async _onSelectFechas(e) {
    this.setState(
      {
        SeleccionFecha: e.target.value,
        defaultOptionFecha: e.target.value,
      },
      () => this.CargarParametrosSolicitud()
    );
  }

  async _onSelectEstado(e) {
    this.setState({
      seleccionEstado: e.target.value,
      defaultOptionEstado: e.target.value,
    });
  }

  async _onSelectTipoSolicitud(e) {
    this.setState({
      seleccionTipoSolicitud: e.target.value,
      defaultOptionTipoSolicitud: e.target.value,
    });
  }

  async cargarDefaultData() {
    if (this.state.UnaVez && this.state.parametrosCargados !== null) {
      await this.cargarResultados();
    }
  }

  cargarResultados = async () => {
    let parametros = this.cargarParametros();
    let consulta = await SolicitudPadronServicio.ConsultaSolicitudesPadron(
      parametros
    );

    if (consulta.EsValido) {
      this.setState({
        datos: consulta.Solicitudes,
        mostrarTabla: true,
        parametrosCargados: parametros,
        UnaVez: false,
      });
      CerrarNotificador();
      localStorage.setItem(
        "DataTables_tbSolicitudesPadron_/cic_externo/Padron/ConsultaSolicitudesPadron",
        null
      );
    } else {
      this.setState({ mostrarTabla: false });
      Notificar("error", consulta.Errores);
    }
  };

  async _onConsultaSolicitudes() {
    await this.cargarResultados();
  }

  render() {
    return (
      <div>
        <div className="card shadow mb-4">
          <div className="card-body">
            <div className="row">
              <div className="col-md-4">
                <div className="card mb-4">
                  <div className="card-header">
                    <h6 className="m-0 font-weight-bold text-primary">
                      Datos Generales
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <label htmlFor="IdClaseDato"> Clase Datos</label>
                      </div>
                      <div className="col-md-8">
                        <select
                          id="IdClaseDato"
                          className="form-control"
                          value={this.state.defaultOptionClaseDato}
                          onChange={(e) => this._onSelectClaseDato(e)}
                        >
                          <option key="Todas" value={"0"}>
                            Todas
                          </option>
                          {this.state.opcionesClaseDatos.map((item) => (
                            <option key={item.nombreConId} value={item.id}>
                              {item.nombreConId}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <label htmlFor="FechaSolicitud">Fecha Envío</label>
                      </div>
                      <div className="col-md-8">
                        <select
                          className="form-control"
                          id="FechaSolicitud"
                          value={this.state.defaultOptionFecha}
                          onChange={(e) => this._onSelectFechas(e)}
                        >
                          <option key="Todas" value={"0"}>
                            Todas
                          </option>
                          {this.state.opcionesFechas.map((item) => (
                            <option key={item} value={item}>
                              {item != null
                                ? moment(item).format("DD/MM/YYYY")
                                : ""}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card">
                  <div className="card-header">
                    <h6 className="m-0 font-weight-bold text-primary">
                      Datos de la Solicitud
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <label htmlFor="TipoEstado"> Estado</label>
                      </div>
                      <div className="col-md-8">
                        <select
                          className="form-control"
                          id="TipoEstado"
                          value={this.state.defaultOptionEstado}
                          onChange={(e) => this._onSelectEstado(e)}
                        >
                          <option key="Todos" value={"0"}>
                            Todos
                          </option>
                          {this.state.opcionesEstados.map((item) => (
                            <option key={item.nombre} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <label htmlFor="TipoSolicitud">Tipo</label>
                      </div>
                      <div className="col-md-8">
                        <select
                          className="form-control"
                          value={this.state.defaultOptionTipoSolicitud}
                          id="TipoSolicitud"
                          onChange={(e) => this._onSelectTipoSolicitud(e)}
                        >
                          <option key="Todos" value={"0"}>
                            Todos
                          </option>
                          {this.state.opcionesTipoSolicitud.map((item) => (
                            <option key={item.nombre} value={item.id}>
                              {item.nombre}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card mb-4">
                  <div className="card-header">
                    <h6 className="m-0 font-weight-bold text-primary">
                      Datos de la Persona
                    </h6>
                  </div>
                  <div className="card-body">
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <label htmlFor="Identificacion">Identificación</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control"
                          id="Identificacion"
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4 col-form-label">
                        <label htmlFor="Nombre">Nombre</label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          className="form-control"
                          id="Nombre"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row col-sm-12">
              <button
                id="btnBuscarSolicitudesPadron"
                onClick={this._onConsultaSolicitudes}
                type="button"
                className="btn btn-primary btn-icon-split"
              >
                <span className="icon text-white-50">
                  <i className="fas fa-search"></i>
                </span>
                <span className="text">Buscar</span>
              </button>

              <button
                id="btnLimpiarFiltros"
                onClick={this.limpiarFiltros}
                type="button"
                className="btn btn-sm btn-light ml-3"
              >
                <i className="fas fa-redo fa-sm mr-1"></i>
                Limpiar filtros
              </button>
            </div>
          </div>
        </div>

        {this.state.mostrarTabla ? (
          <div className="card shadow mb-4">
            <ResultadoConsultaSolicitud
              datos={this.state.datos}
              PaginaInicio={this.state.PaginaDatatable}
              parametrosCargados={this.state.parametrosCargados}
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withRouter(ParametrosConsultaSolicitud);
